export default "__VITE_ASSET__B2hwhC3A__"